import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IComboBox } from "@interfaces/IComboBox";
import "./report-category-selector.scss";

@Component({
    selector: "report-category-selector",
    template: require("./report-category-selector.html")
})
export class ReportCategorySelectorComponent {

    @Input() categoryIndex = 0;
    @Input() columnFilterOptions: IComboBox[] = [];

    @Output() optionChanged = new EventEmitter();

    // ---

    catFilterSelected(option: IComboBox) {
        console.log("catFilterSelected");
        this.categoryIndex = this.columnFilterOptions.indexOf(option);

        this.optionChanged.emit({ option: option, selectedIndex: this.categoryIndex });
    }
}
